module.exports = __webpack_public_path__ + "static/media/drop-file.24e2be54.png";